import apiClient from './client'
import type {
  StatusPage,
  StatusPageCreate,
  StatusPageUpdate,
  StatusPageListResponse,
  SlugCheckResponse,
  PublicStatusPageResponse,
} from '../types'

export const statusPagesApi = {
  // List all status pages for current user
  list: async (): Promise<StatusPageListResponse> => {
    const response = await apiClient.get<StatusPageListResponse>('/status-pages')
    return response.data
  },

  // Get a single status page by ID
  get: async (id: string): Promise<StatusPage> => {
    const response = await apiClient.get<StatusPage>(`/status-pages/${id}`)
    return response.data
  },

  // Create a new status page
  create: async (data: StatusPageCreate): Promise<StatusPage> => {
    const response = await apiClient.post<StatusPage>('/status-pages', data)
    return response.data
  },

  // Update a status page
  update: async (id: string, data: StatusPageUpdate): Promise<StatusPage> => {
    const response = await apiClient.patch<StatusPage>(`/status-pages/${id}`, data)
    return response.data
  },

  // Delete a status page
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/status-pages/${id}`)
  },

  // Check if a slug is available
  checkSlug: async (slug: string, excludeId?: string): Promise<SlugCheckResponse> => {
    const params = new URLSearchParams({ slug })
    if (excludeId) {
      params.append('exclude_id', excludeId)
    }
    const response = await apiClient.get<SlugCheckResponse>(`/status-pages/check-slug?${params}`)
    return response.data
  },

  // Get public status page data (no auth required)
  getPublic: async (slug: string): Promise<PublicStatusPageResponse> => {
    const response = await apiClient.get<PublicStatusPageResponse>(`/status-pages/public/${slug}`)
    return response.data
  },
}
